<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Search Engine Optimization</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>SEO Services</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="details-cover-img" src="assets/img/service/seo-services.png.webp"
                            alt="Search Engine Optimization" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <p class="box-text mb-30">XIPE TECH provides SEO services to business at affordable price with
                            its specialist team of certified SEO experts. We are a professional search engine
                            optimization company physically located in India.
                        </p>
                        <h2 class="box-title">Why Marketing Important?</h2>
                        <div class="sv-gallery-wrapper">
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 mb-5">
                                    <p>Here are some key aspects of SEO:</p>
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul>
                                            <li>Keyword Research</li>
                                            <li>On-Page Optimization</li>
                                            <li>Technical SEO</li>
                                            <li>Content Creation and Optimization</li>
                                            <li>User Experience (UX)</li>
                                            <li>Local SEO</li>
                                            <li>Analytics and Monitoring</li>
                                            <li>Continuous Improvement</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>Remember that SEO is a long-term strategy, and results may take time to
                                        materialize. It requires consistent effort, monitoring, and adaptation to
                                        changes in search engine algorithms and user behavior. By implementing effective
                                        SEO techniques, you can increase your website's visibility, attract more organic
                                        traffic, and improve your online presence.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>